<template>
  <div class="pc-save-btn-group">
    <div v-show="$route.query.method == 'update' && isEditting" class="update">
      <h4 @click="cancelUpdate()">取消更新</h4>
      <div class="pc-preview">
        <h4 @click="recover()">恢复</h4>
        <h4 @click="save()">保存</h4>
      </div>
    </div>

    <div v-show="$route.query.method == 'update' && !isEditting" class="view">
      <h4 @click="view()">预览</h4>
    </div>

    <div v-show="$route.query.method == 'add'" class="add">
      <h4 @click="cancelAdd()">取消添加</h4>
      <h4 @click="add()">添加</h4>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isEditting"],
  methods: {
    cancelUpdate() {
      window.scrollTo(0,0)
      this.$emit("cancelUpdate");
    },
    recover() {
      window.scrollTo(0,0)
      this.$emit("recover");
    },
    save() {
      window.scrollTo(0,0)
      this.$emit("save");
    },
    view() {
      this.$emit("view");
    },
    cancelAdd() {
      window.scrollTo(0,0)
      this.$emit("cancelAdd");
    },
    add() {
      window.scrollTo(0,0)
      this.$emit("add");
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-save-btn-group {
  margin-top: 50px;
  .update,
  .view,
  .add {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .view{
    flex-direction:row-reverse;
  }

  .pc-preview {
    display: flex;
    justify-content: flex-end;
    h4{
        margin-left:10px;
    }
  }
  h4 {
    background: rgba(84, 112, 198, 0.14);
    height: 40px;
    border-radius: 4px;
    padding: 10px 29px 14px;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $timeBtn;
    line-height: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/SaveGroup.vue